import "whatwg-fetch";

export type ProductData = {
  id: string;
  name: string;
  brand: string;
  price: string | null;
  size?: string | null;
  quantity: number;
};

export type ProductParams = {
  styleCode: string;
  name: string;
  designer: string;
  size: string | null;
  price: number | string | null;
};

function stripFlagFromStyleCode(styleCode: string) {
  return styleCode.replace(/([1-9A-Z][A-Z][0-9A-T][0-9A-Z]{3})[A-Z]{2}/, "$1");
}

export default class Product {
  static fromStorage(data: ProductParams) {
    return new Product(data);
  }

  static fromDocumentProductData(productData: ProductData) {
    const styleCode = stripFlagFromStyleCode(productData.id);
    const name = productData.name;
    const designer = productData.brand;
    const size = productData.size ? productData.size : null;
    const price = productData.price;
    return new Product({ styleCode, name, designer, size, price });
  }

  constructor(productData: ProductParams) {
    Object.assign(this, productData);
    // @ts-ignore - Object.assign(this, ...) creates the fields
    this.price = (this.price || 0) - 0;
  }

  forStorage() {
    return this;
  }

  /**
   * Resolves to product designations (rental or subscription). On error, assume rental-only designation.
   * @returns {Promise<{rental: boolean, subscription: boolean}>}
   */
  async designations() {
    // @ts-ignore - Comes from Object.assign(this, ...) magic
    const styleCode = this.styleCode;

    try {
      const response = await fetch(`/api/v1/catalogue-by-style-code?style_codes=${styleCode}`);
      const body = await response.json();

      const styleInfo = body.body.data[0];
      const rental = !styleInfo || styleInfo["designations_include_rental"];
      const subscription = styleInfo && styleInfo["designations_include_subscription"];
      return { rental, subscription };
    } catch (err) {
      console.error(err);
      return { rental: true, subscription: false };
    }
  }
}
